import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import routes from './routes'
import 'babel-polyfill'

import './registerServiceWorker'
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
// import 'material-design-icons-iconfont/dist/material-design-icons.css'
// import '@mdi/font/css/materialdesignicons.css'

//import VueSession from 'vue-session'

import utilities from './plugins/utilities'


import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import axios from "./axios"
import axios_node_backend from "./axios_node_backend"

import Clipboard from 'v-clipboard'


Vue.use(VueMoment, {
    moment,
})



Vue.use(VueRouter)

// Vue.use(Vuetify, {
//     iconfont: 'mdi'
// })
Vue.use(Vuetify)


//Vue.use(VueSession)

Vue.use(Clipboard)

Vue.config.productionTip = false

const router = new VueRouter({
    routes : routes,
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
    //mode: 'history'
})

Vue.mixin(utilities)

//ดัก 401
axios.interceptors.response.use((response) => { // intercept the global error
    utilities.methods.setAuthHeader()
    return response
}, function (error) {
    //console.log("token has expire")
    //alert('เซ็คชั่นหมดอายุ กรุณา login ใหม่อีกค่ะ')
    let originalRequest = error.config
    if (error.response.status === 401 && !originalRequest._retry) { // if the error is 401 and hasent already been retried
        originalRequest._retry = true // now it can be retried
        delete axios.defaults.headers.common['Authorization']
        localStorage.removeItem('svea_emp')
        return router.replace('/login')
        /*
        try{
            utilities.methods.refreshToken()
        }catch(error2){
            for (let i = 0; i < error2.response.data.errors.length; i++) {
                if (error2.response.data.errors[i] === 'TOKEN-EXPIRED') {
                    utilities.methods.logout()
                    return
                }
            }
        }
        */
    }
    if (error.response.status === 404 && !originalRequest._retry) {
        originalRequest._retry = true
        window.location.href = '/'
        return
    }
    // Do something with response error
    return Promise.reject(error)
})

Vue.prototype.$scrollToTop = () => window.scrollTo(0,0)

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
